import { render, staticRenderFns } from "./autoView.vue?vue&type=template&id=19dc755a&scoped=true"
import script from "./autoView.vue?vue&type=script&lang=js"
export * from "./autoView.vue?vue&type=script&lang=js"
import style0 from "./autoView.vue?vue&type=style&index=0&id=19dc755a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19dc755a",
  null
  
)

export default component.exports